const show = ({
  type,
  title,
  message,
  timeToClose,
}) => {
  if (document.querySelector('#dx-toast-list') === null) {
    const toastList = document.createElement('div');
    toastList.id = 'dx-toast-list';
    document.body.appendChild(toastList);
  }

  const toastDiv = document.createElement('div');

  toastDiv.id = `toast_${Math.floor(Math.random() * 10000000000)}`;
  toastDiv.className = `dx-toast dx-toast--${type} hide`;

  const deleteToast = () => {
    const toast = document.querySelector(`#${toastDiv.id}`);
    if (toast) {
      toast.classList.add('hide');
      setTimeout(() => {
        toast.remove();
      }, 1000);
    }
  };

  const toastDivTitleClose = document.createElement('div');
  toastDivTitleClose.className = 'dx-toast-title dx-toast-close';
  toastDivTitleClose.innerHTML = 'X';
  toastDivTitleClose.onclick = deleteToast;
  toastDiv.appendChild(toastDivTitleClose);

  const toastDivTitle = document.createElement('div');
  toastDivTitle.className = 'dx-toast-title';
  toastDivTitle.innerHTML = title;
  toastDiv.appendChild(toastDivTitle);

  const toastDivMessage = document.createElement('div');
  toastDivMessage.className = 'dx-toast-message';
  toastDivMessage.innerHTML = message;
  toastDiv.appendChild(toastDivMessage);

  document.querySelector('#dx-toast-list').appendChild(toastDiv);

  setTimeout(() => {
    document.querySelector(`#${toastDiv.id}`).classList.remove('hide');
  }, 100);

  setTimeout(deleteToast, timeToClose);
};

export function error(title, message) {
  show({
    type: 'error',
    title: message ? title : 'Error',
    message: message || title,
    timeToClose: 8000,
  });
}

export function success(title, message) {
  show({
    type: 'success',
    title: message ? title : 'Sucesso',
    message: message || title,
    timeToClose: 5000,
  });
}
